const apiEndpoint = 'https://gimnazijasvetisava.stellate.sh/';
//const apiEndpoint = 'https://wp.gimnazijasvetisava.edu.rs/index.php?graphql';
export default apiEndpoint;